/* eslint-disable import/prefer-default-export */

'use server';

import API from '~/config/api';
import fetchJson from '~/utils/Fetch/json';

export async function submitCcpaRequest(prevState, formData) {
  const rightToCorrect = formData.get('correct') === 'on';

  const payload = {
    name: formData.get('name'),
    email: formData.get('email'),
    phone: formData.get('phone') || null,
    right_to_know: formData.get('know') === 'on' ? '1' : '0',
    right_to_delete: formData.get('delete') === 'on' ? '1' : '0',
    right_to_correct: rightToCorrect ? '1' : '0',
    right_to_opt_out: formData.get('optOut') === 'on' ? '1' : '0',
    comments: rightToCorrect ? (formData.get('comments') || null) : null,
    source: 'rea',
  };

  const hasRequest = ['right_to_know', 'right_to_delete', 'right_to_correct', 'right_to_opt_out']
    .some((key) => payload[key] === '1');

  if (!hasRequest) {
    return {
      alert: 'error',
      message: 'Please select at least one request type.',
      values: payload,
    };
  }

  try {
    await fetchJson(
      API.ccpaRequest({}),
      API.POST_CONFIG({ data: payload }),
    );
    return {
      alert: 'success',
      message: 'Your privacy request has been submitted successfully.',
      values: {},
    };
  } catch {
    return {
      alert: 'error',
      message: 'There was an error submitting your request. Please try again or contact us directly at support@realestateagents.com',
      values: payload,
    };
  }
}
